<template>
    <div class="vue-data-table-form-text__container" style="width: 100%; height: 100%; min-height: 48px;">
        <v-menu
            v-if="editable"
            v-model="menu"
            width="400"
            :close-on-content-click="false"
            :persistent="false"
            hide-overlay
            bottom
            right
        >
            <template v-slot:activator="{ on, attrs }">
                <button ref="hiddenButton" v-on="on" v-bind="attrs" @click.stop="menu = !menu"></button>
            </template>
            <v-card width="500">
                <v-list-item>
                    <v-list-item-content>
                        <v-textarea
                            v-model="innerModel"
                            clearable
                            no-resize
                            hide-details
                            :rows="1"
                            auto-grow
                            autofocus
                            ref="textarea"
                        >
                        </v-textarea>
                    </v-list-item-content>
                </v-list-item>
                <v-card-actions class="justify-end">
                    <v-btn color="error" text @click="cancel">Cancel</v-btn>
                    <v-btn color="primary" text @click="save">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-menu>
        <icon-wrapper
            @click:icon="onClickIcon"
            :disabled="!editable"
        >
            <vue-data-table-tooltip-text
                :width="option.width"
                :text="text || valueComputed"
                :align="option.align"
                :overflow="option.overflow"
                :description="option.description && option.description(value, item)"
                :color="option.description && option.descriptionColor && option.descriptionColor(value, item)"
                :src="option.description && option.src && option.src(value, item)"
            >
            </vue-data-table-tooltip-text>
        </icon-wrapper>
    </div>
</template>

<script>
import IconWrapper from "./part/EditIconContainer";
import VueDataTableFormBaseText from "@/assets/plugins/vue-data-table/providers/VueDataTableFormBaseText";
import VueDataTableTooltipText from "@/assets/plugins/vue-data-table/components/VueDataTableTooltipText";

export default {
    name: "VueDataTableFormText",
    components: {VueDataTableTooltipText, IconWrapper},
    extends: VueDataTableFormBaseText,
    props:{
    },
    data() {
        return {
            menu: false,
        };
    },
    computed: {
        valueComputed() {
            if (this.value === 0) return "0";
            return this.value;
        },
    },
    watch: {
        menu() {
            if (this.menu) {
                this.innerModel = this.model;
            }
        }
    },
    mounted() {
    },
    activated() {
    },
    methods: {
        onClickIcon() {
            if (!this.editable) return;
            this.$refs.hiddenButton.click();
        },
        save() {
            this.model = this.innerModel;
            this.menu = false;
        },
        cancel() {
            this.innerModel = this.model;
            this.menu = false;
        },
    },
}
</script>

<style scoped>
.vue-data-table-form-text__container {
    display: flex;
    flex-direction: row;
    align-items: start;
    justify-content: start;
    width: 100%;
    height: 100%;
}

.tooltip-text {
    display: flex;
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow-y: hidden;
    max-height: 75px;
    cursor: default;
    width: 100%;
}

/*text 말줄임표 스타일*/
.ellipsis {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: inline-block;
}

/*text 줄바꿈 스타일*/
.word_break {
    word-break: break-all;
    white-space: normal;
}
</style>